import { Outlet } from 'react-router';
import { useTranslation } from 'react-i18next';

/**
 * AuthLayout — centered card layout for login, signup, password reset pages.
 */
export function AuthLayout() {
  const { t } = useTranslation();

  return (
    <div className="flex min-h-screen items-center justify-center bg-background p-4">
      <div className="w-full max-w-md">
        <div className="mb-8 text-center">
          <h1 className="text-2xl font-bold text-foreground">{t('app.name')}</h1>
          <p className="mt-1 text-sm text-muted-foreground">
            {t('app.tagline')}
          </p>
        </div>
        <div className="rounded-lg border border-transparent bg-card p-6 shadow-card dark:border-border">
          <Outlet />
        </div>
      </div>
    </div>
  );
}
